import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import ClearFilterIcon from "../../components/icons/ButtonIcons/ClearFilterIcon";
import {
  Box,
  Button,
  CircularProgress,
  ClickAwayListener,
  Grow,
  IconButton,
  MenuList,
  Paper,
  Popper,
  Tooltip,
  Typography,
} from "@mui/material";
import { useAppSelector } from "../../../hooks/redux";
import { PATHS } from "../../../constants";
import { useLazyGetNotificationsQuery, useMarkNotificationAsReadMutation } from "../../../middleware/notificationApi";
import { NotificationItem } from "../../components/NotificationPopUp/NotificationItem";
import CloseIcon from "@mui/icons-material/Close";
import PlusIcon from "../../components/icons/ButtonIcons/PlusIcon";
import { TooltipProps } from "../../../helpers/materialUITheme";

const Header = ({ handleModalDebbuging, clearFiltersHandler }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const anchorRef = React.useRef(null);
  const [notifications, setNotifications] = useState({});
  const { roleId } = useAppSelector((state) => state.users.info);
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [pageNumber, changePageNumber] = useState(0);

  const [getNotification] = useLazyGetNotificationsQuery();
  const [markNotificationAsRead] = useMarkNotificationAsReadMutation();

  const fetchData = async () => {
    try {
      const response = await getNotification({
        pageNumber: 0,
        excludeSurgardNotifications: false,
      });
      setNotifications({
        ...response?.data,
        hasMore: response?.data?.data.length < response?.data.recordsCount ? true : false,
      });
    } catch (error) {
      console.error("error");
    }
  };

  useEffect(() => {
    open && fetchData();
  }, [open]);

  const markNotification = (array) => {
    markNotificationAsRead(array).then(({ data, error }) => {
      if (!error) {
        fetchData();
      }
    });
  };

  const notiffetchData = () => {
    setLoading(true);
    setTimeout(() => {
      getNotification({
        pageNumber: pageNumber + 1,
      }).then(({ data, isSuccess }) => {
        changePageNumber((prev) => prev + 1);
        setNotifications({
          ...notifications,
          hasMore: data?.data.length + notifications?.data.length < data.recordsCount ? true : false,
          data: [...notifications?.data, ...data.data],
        });
        setLoading(false);
      });
    }, 1000);
  };

  function handleListKeyDown(event) {
    if (event.key === "Tab") {
      event.preventDefault();
      setOpen(false);
    }
  }

  const handleScroll = (e) => {
    const bottom = e.target.scrollHeight - e.target.scrollTop - e.target.clientHeight;
    if (bottom >= 1 && bottom <= 10 && !loading && notifications?.hasMoreData) {
      notiffetchData();
    }
  };

  return (
    <Box className="controllers-header">
      <Typography className="title-page">{t("title_page:controllers")}</Typography>
      <Box className="controllers-header-btns_field">
        <Button ref={anchorRef} className="btn btn-white" onClick={() => setOpen(true)}>
          {t("Диагностика")}
        </Button>
        <Button className="btn btn-white" onClick={handleModalDebbuging.bind(null, true)}>
          {t("button:debugging")}
        </Button>

        <Tooltip title="Очистить все фильтры" componentsProps={TooltipProps} placement="bottom" arrow>
          <Button className="btn btn-white" onClick={clearFiltersHandler}>
            <ClearFilterIcon />
          </Button>
        </Tooltip>

        {(roleId == 1 || roleId == 2) && (
          <Button className="btn btn-primary-fill" onClick={() => navigate(PATHS.ADD_CONTROLLER)}>
            <PlusIcon />
            {t("button:add")}
          </Button>
        )}
      </Box>

      <Popper open={open} anchorEl={anchorRef.current} role={undefined} transition disablePortal sx={{ zIndex: 10000 }}>
        {({ TransitionProps, placement }) => (
          <Grow
            {...TransitionProps}
            style={{
              transformOrigin: placement === "bottom" ? "center top" : "center bottom",
            }}
          >
            <Paper className="paper-wrapper">
              <Box sx={{ position: "absolute", right: "40px", top: "40px" }}>
                <IconButton onClick={() => setOpen(false)} sx={{ padding: 0 }}>
                  <CloseIcon />
                </IconButton>
              </Box>

              <div className="notification-wrapper">
                <div className="notification-title-wrapper">
                  <p className="notification-title">Диагностика</p>
                </div>

                {notifications?.recordsCount > 0 ? (
                  <Box style={{ display: "flex", justifyContent: "flex-end" }}>
                    <Button
                      variant="text"
                      onClick={() => markNotification(notifications.data.map((notification) => notification?.id))}
                    >
                      <Typography className="mark-laber "></Typography>
                    </Button>
                  </Box>
                ) : (
                  ""
                )}

                <ClickAwayListener onClickAway={() => setOpen(false)}>
                  {notifications?.recordsCount > 0 ? (
                    <MenuList
                      autoFocusItem={open}
                      id="menu-list-grow"
                      onKeyDown={handleListKeyDown}
                      onScroll={handleScroll}
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "16px",
                        height: "50vh",
                        overflow: "hidden",
                        overflowY: "auto",
                        paddingBottom: "0px",
                      }}
                    >
                      {notifications.data.map((item) => {
                        return (
                          <NotificationItem key={item?.id} markNotification={markNotification} notification={item} />
                        );
                      })}

                      {loading && (
                        <Box
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          <CircularProgress />
                        </Box>
                      )}
                    </MenuList>
                  ) : (
                    <Box
                      sx={{
                        height: "400px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <Typography> {t("label:no_notifications")}</Typography>
                    </Box>
                  )}
                </ClickAwayListener>
              </div>
              <div className="notification-footer">
                <button
                  onClick={() => markNotification(notifications.data.map((notification) => notification?.id))}
                  className="info"
                >
                  {t("label:mark_all_as_read")}
                </button>
              </div>
            </Paper>
          </Grow>
        )}
      </Popper>
    </Box>
  );
};

export default Header;
